export default __webpack_public_path__ + "static/media/31.ba1bb2b0.jpeg";